import config from "react-global-configuration";

config.set({
  booking: "booking",
  pageNumber: "pageNumber",
  pageSize: "pageSize",
  customer: "customer",
  product: "product",
  subProduct: "sub-product",
  temperature: "temperature",
  shipper: "shipper",
  consignee: "consignee",
  productId: "productId",
  subProductId: "subProductId",
  currency: "currency",
  exceptionReason: "exception-reason",
  v1: "v1",
  employee: "employee",
  vehicle: "vehicle",
  city: "city",
  event: "event",
  tripRoute: "trip-route",
  api: "api",
  country: "country",
  countryId: "country-id",
  odaCity: "oda-city",
  cityId: "city-id",
  clientSubId: "client-sub-id",
  cancel: "cancel",
  industryType: "industry-type",
  salesPerson: "sales-person",
  bySalesPerson: "by-sales-person",
  customerAddress: "customer-address",
  customerSubAccount: "customer-sub-account",
  customerBillingDetail: "customer-billing-detail",
  tripPlan: "tripplan",
  tripType: "trip-type",
  tripLoadType: "trip-load-type",
  employeeId: "employeeId",
  index: "index",
  count: "count",
  operation: "operation",
  position: "position",
  code: "code",
  assign: "assign",
  deliverysheet: "delivery-sheet",
  pallet: "pallet",
  trackingHistory: "tracking-history",
  bookingOperationDetail: "booking-operation-detail",
  assignDelivery: "assign-delivery",
  userName: "user-name",
  rto: "rto",
  wayBill: "waybill",
  region: "region",
  pickup: "pickup",
  getPieceBarCodes: "get-piece-bar-codes",
  getBarCodes: "get-box-tray-piece-barcode-detail",
  scanAtHub: "scan-at-hub",
  getVolumeMetricWeight: "get-volume-metric-weight",
  waybillSticker: "waybill-sticker",
  manualWayBill: "manual-waybill",
  print: "print",
  customerAccountFile: "customer-account-file",
  uploadFile: "upload-file",
  palletCode: "pallet-code",
  subCLientIdQuery: "subClientId",
  subClientQuery: "sub-client-id",
  clientQuery: "client",
  palletSticker: "pallet-sticker",
  customerView: "customer-view",
  filter: "filter",
  customerListViewUser: "customer-list-view-user",
  fileType: "file-type",
  fileTypeId: "file-type-id",
  download: "download",
  tree: "tree",
  podCollection: "pod-collection",
  manifest: "manifest",
  wayBillNo: "wayBillNo",
  reCalculate: "re-calculate",
  submitForInvoicePath: "submit-for-invoice",
  submitForInvoice: "submitForInvoice",
  paginated: "paginated",
  page: "page",
  size: "size",
  division: "division",
  business: "business",
  exceptionCategory: "exception-category",
  cityGroup: "city-group",
  station: "station",
  pieceCount: "piece-count",
  reWeight: "re-weight",
  fleetManPower: "fleet-manpower",
  create: "create",
  podFileOptions: "pod-file-options",
  pod: "pod",
  agreement: "agreement",
  clientId: "client-id",
  agreementProduct: "agreement-product",
  getProduct: "get-product",
  createProduct: "create-product",
  agreementMasterAll: "agreement-master-all",
  master: "master",
  agreementStationPrices: "agreement-station-prices",
  agreementProductId: "agreementProductId",
  agreementStationGroupPrices: "agreement-station-group-prices",
  agreementRateRange: "agreement-rate-range",
  agreementRateRangeMaster: "agreement-rate-range-master",
  agreementRateRangeStationMaster: "agreement-rate-range-station-master",
  updateAgreementStatus: "update-agreement-status",
  fileAttachment: "file-attachment",
  downloadAll: "download-all",
  getWayBill: "get-waybill",
  getFiles: "get-files",
  downloadFile: "download-file",
  podDetails: "pod-details",
  ops: "ops",
  cs: "cs",
  podFiles: "pod-files",
  upload: "upload",
  podFileExceptionReasons: "pod-file-exception-reasons",
  updateGoogleAddress: "update-google-address",
  tracking: "tracking",
  all: "all",
  cashCustomer: "cash-customer",
  subClientId: "client_sub_id",
  address: "address",
  alertNotification: "alert-notification",
  hubStorage: "hub-storage",
  blockCustomer: "block-customer",
  unBlockCustomer: "un-block-customer",
  vehicleLogin: "vehicle-login",
  operationVehicleLogout: "operation-vehicle-logout",
  countryCity: "country-city",
  excelBulkBooking: "excel-bulk-booking",
  updateBookingStatusField: "update-booking-status-field",
  plateNo: "plateNo",
  activateDeactivate: "activate-deactivate-vehicle",
  activateStatus: "activate-status",
  dateFilter: "date-filter",
  notDelivery: "not-delivery",
  rtoRequest: "rto-request",
  report: "report",
  customerFinance: "customer-finance",
  manifestFailDownload: "manifest-fail-download",
  closed: "closed",
  complete: "complete",
  tripPlanNumber: "tripPlanNumber",
  toExcel: "to-excel",
  category: "category",
  platenoFleetCode: "plateno-fleetcode",
  exportToExcel: "export-to-excel",
  manifestChargeReport: "manifest-charge-report",
  vehicleOwner: "vehicle-owner",
  vehicleType: "vehicle-type",
  vehicleStatus: "vehicle-status",
  cashDetail: "cash-detail",
  pendingCash: "pending-cash",
  depositDetails: "deposit-details",
  tripHistory: "trip-history",
  tripId: "trip-id",
  pos: "pos",
  updateManifestProduct: "update-manifest-product",
  email: "email",
  manifestReport: "manifest-report",
  agreementBillPeriod: "agreement-bill-period",
  audit: "audit",
  bookingReschedulePickup: "booking-reschedule-pickup",
  updatePickupDate: "update-pickup-date",
  podTypes: "pod-types",
  countryCityWithOutAgreement: "country-city-with-out-agreement",
  tripplanBan: "trip-plan-ban",
  tripplanDetail: "trip-plan-details",
  updateTripplanDetails: "update-trip-plan-details",
  tripException: "trip-exception",
  tripSchedule: "tripschedule",
  tripScheduleActual: "trip-schedule-actuals",
  refresh: "refresh",
  assignDriver: "assign-driver",
  barcodeGenerator: "barcode-generator",
  tray: "tray",
  getBoxHistory: "get-box-history",
  getBoxes: "get-boxes",
  barcode: "barcode",
  tempratureinfo: "history",
  tempraturedevice: "temperature-device",
  tempwaybill: "waybillno",
  templatest: "latest",
  tempImei: "imei",
  tripWaybillReport: "trip-waybill-report",
  customerReport: "customer-report",
  deliverySheetReport: "delivery-sheet-report",
  cityConsignee: "city-consignee",
  billTypeUpdate: "bill-type-update",
  clearOdaCity: "clear-oda-city",
  updateAdhocDetails: "update-ad-hoc-details",
  tripplanDriverOperation: "trip-plan-driver-operation",
  saveTripplanDriverWeb: "save-trip-plan-driver-web",
  tripDetails: "trip-details",
  tripplanDriverStatus: "trip-plan-driver-status",
  cityShipper: "city-shipper",
  additionalPickupBarcodes: "additional-pickup-barcodes",
  delivery: "delivery",
  pickUp: "pickup",
  bulk: "bulk",
  deliveryDateHistory: "delivery-date-history",
  deleteDelivery: "delete-delivery",
  pickupPieceSticker: "pickup-piece-sticker",
  createSubProduct: "create-subProduct",
  hubStock: "hub-stock",
  locateShipment: "locate-shipment",
  cashCollectionReport: "cash-collection-report",
  duplicate: "duplicate",
  norDelivery: "nor-delivery",
  customerAgreementIRSQuote: "customer-agreement-irs-quote",
  newManualWaybill: "new-manual-waybill",
  newManualSticker: "new-waybill-sticker",
  podInProgress: "pod-in-progress",
  podDispatch: "pod-dispatch",
  podPending: "pod-pending",
  tripSheetPrint: "trip-sheet-print",
  tripSheet: "trip-sheet",
  manifestSheet: "manifest-sheet",
  printDeliverySheet: "delivery-sheet-print",
  wbWiseFleetDetails: "wb-wise-fleet-details",
  podAvailabilityReport: "pod-availability-report",
  exemption: "exemption",
  getStationCountry: "get-station-country",
  getStationCountryId: "get-station-country-id",
  podClosed: "pod-closed",
  podClientSubId: "pod-client-sub-id",
  podDispatchPrint: "pod-dispatch-print",
  uploadByWaybill: "upload-by-waybill",
  downloadByWaybill: "download-by-waybill",
  podConfirm: "pod-confirm",
  getPodWaybills: "get-pod-waybills",
  manifestAudit: "manifest-audit",
  close: "close",
  deActivate: "de-activate",
  trip: "trip",
  driver: "driver",
  pfnReport: "pfn-report",
  industryGroup: "industries-group",
  agreementTracking: "agreement-tracking",
  byWaybill: "by-waybill",
  pieceBarcodeTracking: "piece-barcode-tracking",
  activity: "activity",
  packaging: "packaging",
  marken: "marken",
  truckType: "truck-type",
  dailyActivityReport: "daily-activity-recap-report",
  cndnWaybill: "cn-dn-waybill",
  cnRequest: "cn-request",
  cnRequestDetails: "cn-request-details",
  dnRequestDetails: "dn-request-details",
  cnRequestId: "cn-request-id",
  waybillInfo: "waybill-info",
  dnRequest: "dn-request",
  approve: "approve",
  cashWaybill: "cash-waybill",
  add: "add",
  update: "update",
  getWaybillByTripCode: "get-waybill-by-trip-code",
  getWaybillsDeliverySheetCode: "get-waybills-deliverysheet-code",
  irsWaybill: "irs-waybill",
  packagingTemp: "packaging-temp",
  byPackaging: "by-packaging",
  packagingSize: "packaging-size",
  byPackagingTemp: "by-packaging-temp",
  airportCode: "airport-code",
  shipmentTemperature: "shipment-temperature",
  downloadByCategory: "download-by-category",
  downloadByCategoryId: "download-by-category-id",
  categoryId: "category-id",
  goodTypes: "goodtypes",
  markenKpiReport: "marken-kpi-report",
  markenClientReport: "marken-client-report",
  markenGeneralReport: "marken-general-report",
  pushToOracle: "push-to-oracle",
  productDescription: "product-description",
  customerComplaint: "customer-complaint",
  complaintCategory: "complaint-category",
  complaintPriority: "complaint-priority",
  customerComplaintComment: "customer-complaint-comment",
  byComplaint: "by-complaint",
  complaintStatus: "complaint-status",
  kpiReport: "kpi-report",
  holdTerminalException: "hold-terminal-exception",
  updateInfo: "update-info",
  deleteFile: "delete-file",
  updateFile: "update-file",
  uploadMultipleFile: "upload-multiple-file",
  approveRejectAll: "approve-reject-all",
  getOdometer: "get-odometers",
  vehicleMake: "vehicle-make",
  vehicleModel: "vehicle-model",
  loadType: "load-type",
  bodyType: "body-type",
  vehicleBranding: "vehicle-branding",
  fuelType: "fuel-type",
  purchaseMode: "purchase-mode",
  additionalPermit: "additional-permit",
  approveAll: "approve-all",
  isFinanceConfirmed: "is_finance_confirmed",
  exceptionSubReason: "exception-sub-reason",
  agreementODAPrices: "agreement-oda-prices",
  pickedUpNotDeliveredWaybillsReport: "picked-up-not-delivered-waybills-report",
  waybillsNotInvoicedReport: "waybills-not-invoiced-report",
  manifestSalesman: "manifest-salesman",
  sales: "sales",
  confirm: "confirm",
  manual: "manual",
  cityPort: "city-port",
  enquiry: "enquiry",
  commodity: "commodity",
  packageType: "package-type",
  city_id: "city_id",
  quotation: "quotation",
  new: "new",
  manualWaybill: "manual-way-bill",
  printDetails: "print-details",
  ref_req: "ref_req",
  enquiryId: "enquiry_id",
  printQuotation: "print-quotation",
  updateAccount: "update-account",
  performaReport: "performa-report",
  costingSheetReport: "costing-sheet-report",
  enquiryQuotationId: "enquiryQuotationId",
  finance: "finance",
  manifestForIRS: "manifest-for-irs",
  heads: "heads",
  salesman: "salesman",
  modify: "modify",
  rejectionReasons: "rejection-reasons",
  demurrage: "demurrage",
  listing: "listing",
  occApprovalList: "occ-approval-list",
  occApproval: "occ-approval",
  occApprove: "occ-approve",
  occReject: "occ-reject",
  agingExceptions: "aging-exceptions",
  //TZONE API
  device: "device",
  location: "location",
  reject: "reject",
  pickupException: "pickup-exception",
  detail: "detail",
  pieceLevel: "piece-level",
  dispatchWorkstation: "dispatch-workstation",
  pickupPieceStickerBulk: "new-pickup-piece-sticker-bulk",
  gpsStatus: "gps-status",
  missPickUpReport: "miss-pickup-report",
  director: "director",
  vehicleVisibility: "vehicle-visibility",
  assignment: "assignment",
  fleet: "fleet",
  pieceBarcode: "piece-barcode",
  vehicleStatusHistory: "vehicle-status-history",
  notifyDriver: "notify-driver",
  findValidAgreementDetail: "find-valid-agreement-detail",
  fodCod: "fod-cod",
  vehicleTrackingReport: "vehicle-tracking-report",
  vehicleManifestPrint: "vehicle-manifest-print",
  block: "block",
  subAccount: "sub-account",
  adhocDrivers: "adhoc-drivers",
  adhocVehicles: "adhoc-vehicles",
  adhocFleetAssignment: "adhoc-fleet-assignment",
  findEmployeeByPositionId: "find-employees-by-positions-id",
  uploadMultipleIdFiles: "upload-multiple-id-file",
  allEmployee: "all-employee",
  uploadDeliveredPod: "upload-delivered-pod",
  getPickupDateHistory: "get-pickup-date-history",
  updateFodCod: "update-fod-cod",
  calendar: "calendar",
  businessGroup: "business-group",
  podBarcode: "pod-barcode",
  occ: "occ",
  vehicleFuelTracking: "vehicle-fuel-tracking",
  user: "user",
  resetPassword: "reset-password",
  odometerTracking: "odometer-tracking",
  deliverySheetVoucher: "delivery-sheet-voucher",
  vehicleNotificationAlert: "vehicle-notification-alert",
  getIdleVehicleStates: "getIdleVehicleStates",
  agreementStationPricesMaster: "agreement-station-prices-master",
  agreementStationGroupPricesMaster: "agreement-station-group-prices-master",
  manualWaybillApprovedRejected: "approved-rejected",
  manualWaybillApprovedRejectedPaginated: "approved-rejected-paginated",
  getActiveProducts: "get-active-products",
  getVolumeMetricWeightBulk: "get-volume-metric-weight-bulk",
  volumetricBulkApprove: "volumetric-bulk-approve",
  canBulkApproveVolumetric: "can-bulk-approve",
  volumetricCustomerConfigs: "volumetric-customer-configs",
  saveVolumetricCustomerConfigs: "save-volumetric-customer-configs",
  volumetricEmployeeConfigs: "volumetric-employee-configs",
  saveVolumetricEmployeeConfigs: "save-volumetric-employee-configs",
});

export default config;
